// RelatoriosPagamentos.js
import React, { useState } from 'react';
import { FaArrowLeft, FaSearch, FaFilter, FaFilePdf, FaFileExcel } from 'react-icons/fa';
import styles from './RelatoriosPagamentos.module.css';
import DetalhesModal from './DetalhesModal';


const RelatoriosPagamentos = () => {
  const [filters, setFilters] = useState({
    year: '2025',
    month: '05',
    type: 'all',
    status: 'all'
  });
  const [detalhesModalOpen, setDetalhesModalOpen] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const pagamentos = [
    {
      id: 1,
      code: '20250023',
      student: 'Marcos André',
      type: 'Mensalidade',
      amount: 1130,
      date: '2025-05-02',
      method: 'MPesa',
      status: 'paid'
    },
    // outros...
  ];

  const openDetalhes = (payment) => {
    setSelectedPayment(payment);
    setDetalhesModalOpen(true);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <button onClick={() => window.location.href = 'dashboard'}>
          <FaArrowLeft /> Voltar
        </button>
        <h2>Relatórios de Pagamentos</h2>
      </div>

      <div className={styles.filtros}>
        <select value={filters.year} onChange={(e) => setFilters({ ...filters, year: e.target.value })}>
          {[...Array(10)].map((_, i) => <option key={i} value={2025 + i}>{2025 + i}</option>)}
        </select>

        <select value={filters.month} onChange={(e) => setFilters({ ...filters, month: e.target.value })}>
          {[...Array(12)].map((_, i) => {
            const val = (i + 1).toString().padStart(2, '0');
            return <option key={i} value={val}>{val}</option>;
          })}
        </select>

        <select value={filters.type} onChange={(e) => setFilters({ ...filters, type: e.target.value })}>
          <option value="all">Todos</option>
          <option value="Matrícula">Matrícula</option>
          <option value="Mensalidade">Mensalidade</option>
        </select>

        <select value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })}>
          <option value="all">Todos</option>
          <option value="paid">Pago</option>
          <option value="pending">Pendente</option>
          <option value="overdue">Atrasado</option>
        </select>
      </div>

      <table className={styles.tabela}>
        <thead>
          <tr>
            <th>Código</th>
            <th>Aluno</th>
            <th>Tipo</th>
            <th>Valor</th>
            <th>Forma</th>
            <th>Data</th>
            <th>Status</th>
            <th>Detalhes</th>
          </tr>
        </thead>
        <tbody>
          {pagamentos.map((p) => (
            <tr key={p.id}>
              <td>{p.code}</td>
              <td>{p.student}</td>
              <td>{p.type}</td>
              <td>R$ {p.amount.toFixed(2)}</td>
              <td>{p.method}</td>
              <td>{p.date}</td>
              <td>
                <span className={styles[p.status]}>
                  {p.status === 'paid' ? 'Pago' : p.status === 'pending' ? 'Pendente' : 'Atrasado'}
                </span>
              </td>
              <td>
                <button className={styles.btnDetalhes} onClick={() => openDetalhes(p)}>Ver</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <DetalhesModal
        isOpen={detalhesModalOpen}
        onClose={() => setDetalhesModalOpen(false)}
        pagamento={selectedPayment}
      />
    </div>
  );
};

export default RelatoriosPagamentos;
